import { create } from 'zustand';

import { IProductStore } from './types';

export const productStoreValues: Readonly<IProductStore> = {
  id: '',
  order: 0,
  imgId: '',
  status: null,
  identities: [],
  exclusions: [],
  initialValues: {
    name: '',
    regions: [],
    quantity: 0,
    productId: '',
    sponsorCode: '',
    imageMetadataId: '',
    effectivePeriods: [],
    receiptAcceptanceDaysThreshold: 14,
  },
};

export const productStore = create<IProductStore>()(() => productStoreValues);
